import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map, Observable, shareReplay } from 'rxjs';
import { SelectBank } from '@shared/models/bank.model';
import { SelectData } from '@shared/models';

@Injectable({
  providedIn: 'root',
})
export class BankService {
  private readonly API = `${environment.baseUrl}/bank`;
  private cache$?: Observable<SelectData[]>;

  constructor(private http: HttpClient) {}

  getAll(): Observable<SelectBank[]> {
    return this.http.get<SelectBank[]>(`${this.API}/all`);
  }

  getAsSelectOptions(): Observable<SelectData[]> {
    if (!this.cache$) {
      this.cache$ = this.getAll().pipe(
        map((banks) => banks.map((b: any) => ({ label: b.code + ' - ' + b.longName, value: b.bankId }))),
        shareReplay(1),
      );
    }
    return this.cache$;
  }
}
